import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function FoundersSection() {
  return <section className="w-full bg-brand-cream py-24 md:py-40 border-t border-gray-200" data-id="element-171">
      <div className="container mx-auto px-4 max-w-7xl flex flex-col items-center" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mb-20" data-id="element-173">
          <span className="text-brand-navy font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-174">
            {siteConfig.founders.eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-[48px] font-bold text-brand-navy mb-8 leading-tight" data-id="element-175">
            {siteConfig.founders.headline}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-light" data-id="element-176">
            {siteConfig.founders.body}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row gap-12 sm:gap-24 justify-center items-center" data-id="element-177">
          {siteConfig.founders.team.map((founder, idx) => <div key={idx} className="text-center" data-id="element-178">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden mb-6 mx-auto border-4 border-white shadow-2xl" data-id="element-179">
                <img src={founder.image} alt={founder.name} className="w-full h-full object-cover" data-id="element-180" />
              </div>
              <h3 className="text-2xl font-bold text-brand-navy mb-1" data-id="element-181">
                {founder.name}
              </h3>
              <p className="text-base text-muted-foreground font-light" data-id="element-182">
                {founder.title}
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}